import React from 'react';
import { useNavigate } from 'react-router-dom';

const currentUrl = window.location.href;
let redirectUrl: string = '/product';
let isZoneUAE: boolean = false;
if (currentUrl.includes('uae')) {
  redirectUrl = '/uae/product';
  isZoneUAE = true;
} else {
  redirectUrl = '/product';
  isZoneUAE = false;
}
function CtcCard() {
  const navigate = useNavigate();
  return (
    <div className="flex lfex-col justify-center items-center min-w-full">
      <div className="flex flex-row justify-between items-center rounded-3xl mt-20 mb-28 max-lg:mb-16 w-[80%] max-sm:w-[90%] relative overflow-hidden bg-[#0B0B0B]">
        <span className="absolute transform -translate-x-1/2 bg-golden-blur-pattern bg-cover bg-no-repeat bg-center shadow-[#f5d29e] z-[150] h-[500px] w-[500px] max-sm:h-[220px] max-sm:w-[300px] -top-[180px] left-[80px] max-sm:-top-[100px] max-sm:left-[30px]"></span>
        {/* stars and circles */}
        <span className="absolute left-[150px] max-sm:left-[120px] transform -translate-x-1/2 top-[20px] bg-[#de9f41] h-3 w-3 max-sm:h-1 max-sm:w-1 rounded-full shadow-2xl shadow-[#f5d29e] z-[150] "></span>
        <span className="absolute left-[520px] max-sm:left-[220px] transform -translate-x-1/2 top-[520px] bg-[#c3934b] max-sm:h-2 max-sm:w-2 h-5 w-5 rounded-full shadow-2xl shadow-[#f5d29e] z-[150] xxl:hidden"></span>
        <span className="absolute left-[250px] max-sm:left-[60px] transform -translate-x-1/2 top-[260px] max-sm:top-[100px] bg-[#cd9542] h-3 w-3 rounded-full shadow-2xl shadow-[#f5d29e] z-[150]  max-sm:hidden"></span>
        <span className="absolute left-[350px] max-xl:left-[250px] transform -translate-x-1/2 top-[50px] bg-sparkle-pattern bg-cover max-sm:h-8 max-sm:w-8  h-16 w-16 bg-no-repeat bg-center shadow-[#f5d29e] z-[150] max-sm:hidden"></span>
        <span className="absolute left-[300px] max-sm:left-[150px] transform -translate-x-1/2 top-[460px] max-sm:top-[150px] bg-sparkle-pattern bg-cover h-12 w-12 bg-no-repeat bg-center shadow-[#f5d29e] z-[150] max-sm:hidden"></span>
        <span className="absolute left-[300px] max-sm:left-[180px] transform -translate-x-1/2 top-[460px] max-sm:top-[190px] bg-sparkle-pattern bg-cover h-12 w-12 bg-no-repeat bg-center shadow-[#f5d29e] z-[150] max-sm:hidden"></span>
        <span className="absolute left-[300px] max-sm:left-[120px] transform -translate-x-1/2 top-[460px] max-sm:top-[140px] bg-sparkle-pattern bg-cover h-12 w-12 bg-no-repeat bg-center shadow-[#f5d29e] z-[150] max-sm:hidden"></span>

        <span className="absolute left-[30px] max-sm:left-[20px] transform -translate-x-1/2 top-[480px] max-sm:top-[160px] bg-sparkle-pattern bg-cover h-12 w-12 max-sm:h-8 max-sm:w-8 bg-no-repeat bg-center shadow-[#f5d29e] z-[150] "></span>
        <span className="absolute left-[30px] max-sm:left-[180px] transform -translate-x-1/2 top-[480px] max-sm:top-[170px] bg-sparkle-pattern bg-cover h-12 w-12 max-sm:h-8 max-sm:w-8 bg-no-repeat bg-center shadow-[#f5d29e] z-[150]"></span>
        <span className="absolute left-[30px] max-sm:left-[20px] transform -translate-x-1/2 top-[480px] max-sm:top-[150px] bg-sparkle-pattern bg-cover h-12 w-12 bg-no-repeat bg-center shadow-[#f5d29e] z-[150] max-sm:hidden"></span>
        <span className="absolute left-[620px] transform -translate-x-1/2 top-[450px] bg-sparkle-pattern bg-cover max-sm:h-8 max-sm:w-8 h-16 w-16 bg-no-repeat bg-center  max-xl:hidden z-[150] max-lg:hidden"></span>
        <span className="absolute left-[620px] transform -translate-x-1/2 top-[450px] bg-sparkle-pattern bg-cover max-sm:h-8 max-sm:w-8 h-16 w-16 bg-no-repeat bg-center  max-xl:hidden z-[150] max-sm:hidden"></span>
        <span className="absolute left-[620px] transform -translate-x-1/2 top-[450px] bg-sparkle-pattern bg-cover max-sm:h-8 max-sm:w-8 h-16 w-16 bg-no-repeat bg-center  max-xl:hidden z-[150] max-sm:hidden"></span>

        <div className="flex flex-col justify-center items-start w-[40%] h-auto px-6 xxl:px-12 max-sm:px-4 z-[120]">
          <span className="text-responsive leading-responsive font-bold text-left text-white w-full p-4 max-lg:p-3 max-sm:p-2 xl:mb-12 lg:mb-10 md:mb-6 max-md:mb-6 max-xs:mb-6">
            Endless <br /> Adventures <br />
            Await
          </span>
          <button
            type="submit"
            title="shop-now"
            onClick={() => {
              navigate(redirectUrl);
            }}
            className="p-4 xxl:p-6 max-lg:p-3 max-sm:p-1 bg-white text-button-responsive max-sm:rounded-lg rounded-2xl w-[65%] max-sm:w-[95%] ml-4 max-sm:ml-2 font-semibold z-[9999]"
          >
            Shop now
          </button>
        </div>
        <div className="w-[50%] max-sm:w-[80%] h-full relative z-[100]">
          <img
            src={
              isZoneUAE
                ? 'https://res.cloudinary.com/dx6dieevo/image/upload/f_auto,q_auto:good,w_auto/v1744051607/UAE/jo9addny5vj6mwxegauk.png'
                : 'https://res.cloudinary.com/dx6dieevo/image/upload/f_auto,q_auto:good,w_auto/v1723730400/pixa-pie/features/ctc_card_bg.webp'
            }
            alt="ctc-card"
            className="object-cover max-sm:object-fill w-full h-full min-h-[240px]"
          />
        </div>
      </div>
    </div>
  );
}

export default React.memo(CtcCard);
